import React from 'react';
import { apiAction } from 'api/api';
import styled from "styled-components";
import { getSearchURL, getSearchURLForRatios } from 'api/urls';
import { useHistory } from "react-router";
import AsyncSelect from 'react-select/async';
import { getQueryParams } from 'utils/Utils';
import { addLabelValue } from 'proptypes/ArrayProptype';

const T = {
  bg:   '#F6F5F0',
  card: '#FFFFFF',
  soft: '#F0EEE6',
  line: '#E5E2D8',
  ink:  '#232821',
  mut:  '#6E766C',
  acc:  '#2E9E7A',
};

const CompanySearch = (props) => {
    const { selected, handleInputChange, sector_name } = props
    const history = useHistory()
    const querryParams = getQueryParams(history.location.search)

    const handleRemoveValue = (e) => {
        if (!handleInputChange) return;
        const { name: buttonName } = e.currentTarget;
        const removedValue = selected.find((val) => val.value === buttonName);
        if (!removedValue) return;
        handleInputChange(
            selected.filter((val) => val.value !== buttonName),
            { action: "remove-value", removedValue }
        );
    };

    const loadOptions = (inputValue) =>
        new Promise(async (resolve) => {
            if (sector_name) {
                let res = await apiAction({ url: getSearchURLForRatios(sector_name, inputValue) })
                resolve(res ? addLabelValue(res, "name", "symbol") : '') 
            } else {
                let res = await apiAction({ url: getSearchURL(inputValue) })
                resolve(res ? addLabelValue(res, "name", "symbol") : '')
            }
        })

    return (
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', width: '100%', gap: 16, flexWrap: 'wrap' }}>
            <ValuesContainer style={{ flex: 1 }}>
                {selected.map((val) => (
                    <Value key={val.value}>
                        {val.label}
                        {querryParams.company__symbol !== val.value ? (
                            <XButton name={val.value} onClick={handleRemoveValue}>
                                ✕
                            </XButton>
                        ) : null}
                    </Value>
                ))}
            </ValuesContainer>

            <div style={{ flex: '0 0 300px' }}>
                <AsyncSelect
                    isMulti
                    cacheOptions
                    value={selected}
                    isClearable={false}
                    styles={customStyles}
                    openMenuOnClick={false}
                    loadOptions={loadOptions}
                    onChange={handleInputChange}
                    placeholder={<span style={{ color: T.mut, textTransform: 'capitalize' }}>+ Add Company...</span>}
                    controlShouldRenderValue={false}
                    backspaceRemovesValue={false}
                    components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null
                    }}
                />
            </div>
        </div>
    )
}

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        fontSize: 13,
        textAlign: "left",
        cursor: "pointer",
        color: state.isSelected ? T.acc : T.ink,
        backgroundColor: state.isSelected ? `${T.acc}18` : T.card,
    }),
    container: base => ({ ...base, width: "100%" }),
    control: base => ({
        ...base,
        minHeight: 34,
        height: 34,
        paddingLeft: 8,
        borderRadius: 999,
        border: `1px solid ${T.line}`,
        backgroundColor: T.soft,
        boxShadow: "none",
        "&:hover": { borderColor: T.acc },
        cursor: "pointer",
        margin: 0,
    }),
    dropdownIndicator: base => ({ ...base, display: "none" }),
    indicatorSeparator: base => ({ ...base, display: "none" }),
    valueContainer: base => ({ ...base, padding: "0 4px" }),
    placeholder: base => ({
        ...base,
        color: T.mut,
        fontSize: 12.5,
        fontFamily: "'Instrument Sans', system-ui, sans-serif",
    }),
    input: base => ({
        ...base,
        fontSize: 12.5,
        margin: 0,
        padding: 0,
        color: T.ink,
        fontFamily: "'Instrument Sans', system-ui, sans-serif",
    }),
    menu: base => ({
        ...base,
        borderRadius: 12,
        boxShadow: '0 1px 2px rgba(35,40,33,.04), 0 4px 16px rgba(35,40,33,.06)',
        border: `1px solid ${T.line}`,
        overflow: 'hidden',
        zIndex: 100,
    })
};

export default CompanySearch;

const ValuesContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
`;

const Value = styled.div`
    display: flex;
    align-items: center;
    padding: 6px 12px;
    font-size: 11.5px;
    font-weight: 600;
    color: ${T.ink};
    background-color: ${T.bg};
    border: 1px solid ${T.line};
    border-radius: 999px;
    user-select: none;
`;

const XButton = styled.button`
    all: unset;
    margin-left: 8px;
    color: ${T.mut};
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 10px;
    &:hover { color: #bb392d; }
`;
